export class Fetising {
  /**
   * 
   * @param {import("vue").App<Element>} app 
   * @param {Object<string, any>} options
   */
  constructor(app, options) {
    this.app = app;
    this.options = options;
  }

  get $one() {
    return this.app.config.globalProperties.$one;
  }

  isLogged() {
    return this.$one.account?.client?.segments?.additionalSegments || false;
  }

  isVE() {
    if (!this.isLogged()) return false;
    for (let segment of this.$one.account.client.segments.additionalSegments) {
      if (segment.externalId.startsWith("VE")) {
        return true;
      }
    }
    return false;
  }

  isVF() {
    if (!this.isLogged()) return false;
    for (let segment of this.$one.account.client.segments.additionalSegments) {
      if (segment.externalId.startsWith("VF")) {
        return true;
      }
    }
    return false;
  }

  /**
   * 
   * @returns {boolean}
   */
  isAdmin() {
    const admins = [ "org:1fa34c50-d73f-4973-b40b-324537f2ef86" ];
    return this.one().isInitialized && admins.includes(this.one().account.client.id);
  }

  /**
   * 
   * @returns {number}
   */
  customerGroup() {
    const MAP = {
      VF_ALAP: 2,
      VF_TORZS: 4,
      VF_KIEMELT: 5,
      VF_STRAT: 5,
      VE1KER: 6,
      VE2SZKER: 7,
      VE3ESZKER: 8
    };
    for (let segment of this.$one.account.client.segments.additionalSegments) {
      if (segment.externalId in MAP) {
        return MAP[segment.externalId];
      }
    }
    return 2;
  }

  onecall(service, method, payload) {
    return new Promise((resolve, reject) => {
      const meta = crypto.randomUUID();
      const callId = crypto.randomUUID();

      function callback(message) {
        const { data, type } = message.data;
        if (type === "one:method:result" && data.callId === callId) {
          window.removeEventListener("message", callback);
          if (!data.isException) {
            resolve(data.result);
          } else {
            reject(new Error(data));
          }
        }
      }
      window.addEventListener("message", callback.bind(this));
      window.parent.postMessage({data: {callId, service, method, payload}, meta: {id: meta}, type: "one:method:call"}, process.env.VUE_APP_ORIGIN);
    });
  }

  sztkmcall(service, method, payload) {
    return new Promise((resolve, reject) => {
      const meta = crypto.randomUUID();
      const callId = crypto.randomUUID();

      function callback(message) {
        const { data, type } = message.data;
        if (type === "sztkm:method:result" && data.callId === callId) {
          window.removeEventListener("message", callback);
          if (!data.isException) {
            resolve(data.result);
          } else {
            reject(new Error(data));
          }
        }
      }
      window.addEventListener("message", callback.bind(this));
      window.parent.postMessage({data: {callId, service, method, payload}, meta: {id: meta}, type: "sztkm:method:call"}, process.env.VUE_APP_ORIGIN);
    });
  }

  *iterateArray(arr) {
    for (let i = 0; i < arr.length; i++) {
      yield arr[i];
    }
  }
}

const _default = {
  /**
   * 
   * @param {import("vue").App<Element>} app 
   * @param {Object<string, any>} options
   */
  install: (app, options) => {
    const obj = new Fetising(app, options)
    app.config.globalProperties.$fetising = obj;
  }
};

export default _default;